import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../../../shared/models/admin';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Primeiro verifica se está autenticado
  if (!authService.isAuthenticatedSync()) {
    router.navigate(['/auth/login'], { 
      queryParams: { returnUrl: state.url } 
    });
    return false;
  }

  // Pega os roles permitidos da rota
  const allowedRoles: UserRole[] = route.data['roles'] || [];
  
  // Se não especificou roles, permite acesso (comportamento padrão)
  if (allowedRoles.length === 0) {
    return true;
  }

  // Verifica se o usuário atual tem um dos roles permitidos
  const currentUser = authService.currentUser();
  const userRole = currentUser?.role as UserRole;

  if (!userRole || !allowedRoles.includes(userRole)) {
    // Se não tem permissão, redireciona para página principal
    router.navigate(['/']);
    return false;
  }

  return true;
};

// Função utilitária para verificar permissões em componentes
export const hasRole = (authService: AuthService, ...roles: UserRole[]): boolean => {
  const currentUser = authService.currentUser();
  const userRole = currentUser?.role as UserRole;
  return userRole ? roles.includes(userRole) : false;
};

// Função utilitária para verificar se é admin ou owner
export const isAdminOrOwner = (authService: AuthService): boolean => {
  return hasRole(authService, 'Admin', 'Owner');
};

// Função utilitária para verificar se é owner
export const isOwner = (authService: AuthService): boolean => {
  return hasRole(authService, 'Owner');
};

// Função utilitária para verificar se é reader
export const isReader = (authService: AuthService): boolean => {
  return hasRole(authService, 'Reader');
};